import { DateTime } from "@grapecity/wijmo";
import { OvertimePreliquidate } from "../models/OvertimePreliquidateModel";
import { requests } from "../../../../../services/external/APIs";

const API_URL = 'dublin/api/v1/liquidate'

export const getPreliquidateOvertimeListByUser = async (StartDate: DateTime, EndDate: DateTime) : Promise<OvertimePreliquidate> => 
    requests.post(`${API_URL}/get-preliquidate-overtimes-by-user`,{StartDate, EndDate});